import { TShopGood } from './good';
import { TService } from './service';
import { TTariff, TTariffGridItem } from './tariff';
import { IUser, IWorker } from './user';

export enum EPaymentMethod {
  CARD = 'CARD',
  DEPOSIT = 'DEPOSIT',
  CASH = 'CASH',
  BONUS = 'BONUS',
  COMPOSITE = 'COMPOSITE',
  CLOUD_PAYMENTS = 'CLOUD_PAYMENTS',
  POSTPAID = 'POSTPAID',
  TINKOFF_SBP = 'TINKOFF_SBP',
  KASPI_QR = 'KASPI_QR',
  KASPI_CARD = 'KASPI_CARD',
  KASPI_PAY = 'KASPI_PAY',
  STRIPE = 'STRIPE',
  BEPAID_ERIP = 'BEPAID_ERIP',
}
export enum EPaymentItemType {
  GOOD = 'GOOD',
  SERVICE = 'SERVICE',
  TARIFF = 'TARIFF',
  DEPOSIT = 'DEPOSIT',
  BONUS = 'BONUS',
}

export enum EShopItem {
  GOOD = 'GOOD',
  SERVICE = 'SERVICE',
  TARIFF = 'TARIFF',
  COMBO = 'COMBO',
}

export type TShopItem = ITariffShopItem | IGoodShopItem | IServiceShopItem;
export type TPaymentItem =
  | ITariffPaymentItem
  | IServicePaymentItem
  | IGoodPaymentItem
  | IDepositPaymentItem
  | IBonusPaymentItem;

export type Combo = {
  id: number;
  title: string;
  cost: number;
  quantity?: number;
  use_global_discounts: boolean;

  tariff: TTariffGridItem;

  items?: Array<{
    entity_type: EPaymentItemType.GOOD | EPaymentItemType.SERVICE;
    amount: number;
    price: number;

    entity: TService | TShopGood;
  }>;
};

export interface IBaseShopItem {
  id: number;
  cost: number;
  amount: number;
  use_global_discounts: boolean;
  comboId?: number;
}

export interface ITariffShopItem extends IBaseShopItem {
  original: TTariff;
  type: EPaymentItemType.TARIFF;
}

export interface IGoodShopItem extends IBaseShopItem {
  original: TShopGood;
  sign?: string;
  type: EPaymentItemType.GOOD;
}

export interface IServiceShopItem extends IBaseShopItem {
  original: TService;
  type: EPaymentItemType.SERVICE;
}

export interface IBasePaymentItem {
  id: number;
  amount: number;
  sum: number;
  type: EPaymentItemType;
}

export interface IServicePaymentItem extends IBasePaymentItem {
  type: EPaymentItemType.SERVICE;
  entity: TService;
}

export interface ITariffPaymentItem extends IBasePaymentItem {
  type: EPaymentItemType.TARIFF;
  entity: TTariff;
}

export interface IGoodPaymentItem extends IBasePaymentItem {
  type: EPaymentItemType.GOOD;
  sign?: string;
  entity: TShopGood;
}

interface IDepositPaymentItem extends IBasePaymentItem {
  type: EPaymentItemType.DEPOSIT;
}

interface IBonusPaymentItem extends IBasePaymentItem {
  type: EPaymentItemType.BONUS;
}

export enum EPaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}

export type TPayment = {
  id: number;
  method: EPaymentMethod;
  client?: Pick<IUser, 'nickname' | 'phone' | 'uuid'>;
  sum: number;
  sums: {
    bonus: number;
    cashback: number;
    deposit: number;
    promo_code: number;
  };
  bonus: number;
  created_at: string;
  is_refunded: boolean;
  not_refundable: boolean;
  items: Array<TPaymentItem>;
  card_sum?: number;
  cash_sum?: number;
  status?: EPaymentStatus;
  client_session: {
    hosts: {
      finished_at: string;
      started_at: string;
      host: {
        alias: string;
        // group: {
        //   title: string;
        // };
      };
    }[];
    started_at: string;
    finished_at: string;
  };
  __typename: 'Payment';
};

export type IPaymentHistoryItem = {
  created_at: string;
  title: string;
  amount: number;
  sum: number;
  card_sum: number;
  cash_sum: number;
  worker: Pick<IWorker, 'last_name' | 'first_name'>;
  paymentMethod: EPaymentMethod;
  items: Array<TPaymentItem>;
  is_refunded: boolean;
  bonus: number;
};
